import React from 'react';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateClearer from '../../sections/dashboard/users/CreateClearer';
import CreateClearerModal from '../../sections/dashboard/users/CreateClearerModal';

const ClearerUser = () => {
  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <CreateClearer />
          <TableComponent
            tableBaseUrl="authentication-service/v1/clearers"
            tableHeader={[
              'firstName',
              'lastName',
              'role',
              'phoneNumber',
              'email',
              'verified',
            ]}
            mappingData={{
              firstName: 'First Name',
              lastName: 'Last Name',
              role: 'Role',
              phoneNumber: 'Phone Number',
              email: 'Email',
              verified: 'Verified',
            }}
          />
        </Container>
        <Modal>
          <CreateClearerModal />
        </Modal>
      </ModalProvider>{' '}
    </TableRefreshProvider>
  );
};

export default ClearerUser;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
